var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from '../../globalVue';
import RejectStockInOrderService from '../../api/RejectStockInOrderService';
import Header from './components/Header.vue';
import Detail from './Detail.vue';
import Add from './Add.vue';
import _ from "lodash";
var RejectStockInOrder = (function (_super) {
    __extends(RejectStockInOrder, _super);
    function RejectStockInOrder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.dialogVisible = false;
        _this.reject_reason = '';
        return _this;
    }
    RejectStockInOrder.prototype.created = function () {
        this.service = RejectStockInOrderService.getInstance();
    };
    RejectStockInOrder.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
    };
    RejectStockInOrder.prototype.toPage = function (order_id, type) {
        this.addTab({
            component: type === 'detail' ? Detail : Add,
            title: '退货入库单',
            showExist: true,
            name: 'rejectStockInOrder_' + type + order_id,
            cprops: {
                order_id: order_id,
                Root_PageAuth: this.Root_PageAuth,
                opener: this,
            },
        });
        window._czc.push(['_trackEvent', '退货入库单', "\u9000\u8D27\u5165\u5E93\u5355" + (type === 'detail' ? '详情' : '修改')]);
    };
    RejectStockInOrder.prototype.audit = function () {
        this.operationConfirm('audit');
    };
    RejectStockInOrder.prototype.discard = function () {
        this.operationConfirm('discard');
    };
    RejectStockInOrder.prototype.closeReject = function () {
        this.dialogVisible = false;
    };
    RejectStockInOrder.prototype.reject = function () {
        if (!this.checkSelectIds()) {
            return;
        }
        this.dialogVisible = true;
        this.reject_reason = '';
    };
    RejectStockInOrder.prototype.doReject = function () {
        var _this = this;
        if (this.reject_reason.length > 100) {
            this.$message.error('驳回原因不能超过100字');
            return;
        }
        var params = {
            order_ids: this.getSelectIds(),
            reject_reason: this.reject_reason,
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.reject(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
            }
            else {
                _this.$message.success(res.data.msg || '操作成功');
            }
            window._czc.push([
                '_trackEvent',
                '退货入库单',
                '退货入库单驳回',
            ]);
            _this.closeReject();
            _this.getList();
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    RejectStockInOrder.prototype.operationConfirm = function (type) {
        var _this = this;
        if (!this.checkSelectIds())
            return;
        var confirmTips = {
            audit: {
                operationText: '退货入库单审核',
                tipCotent: '审核后将不能修改，确定审核吗？',
            },
            discard: {
                operationText: '退货入库单废弃',
                tipCotent: '确认后会废弃退货入库单，且不可修改，确定废弃吗？',
            },
        };
        this.$confirm(confirmTips[type] && confirmTips[type].tipCotent).then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var order_ids = _this.getSelectIds();
            _this.service[type]({
                order_ids: order_ids,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg || '操作成功');
                }
                window._czc.push([
                    '_trackEvent',
                    '退货入库单',
                    confirmTips[type] && confirmTips[type].operationText,
                ]);
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    RejectStockInOrder.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    RejectStockInOrder.prototype.getSelectIds = function () {
        var orderIds = this.selectRows.map(function (item) { return item.order_id; });
        return orderIds.join(',');
    };
    RejectStockInOrder.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    RejectStockInOrder.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    RejectStockInOrder.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.listData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            var listGoods = res.data.data;
            listGoods.map(function (item) {
                item.realityStoreIn = Math.floor(item.order_warehousing_amount * item.sales_unit_coefficient * 10000) / 10000;
                item.realityLose = Math.floor(item.order_loss_amount * item.sales_unit_coefficient * 10000) / 10000;
                return item;
            });
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.listData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    RejectStockInOrder.prototype.search = function (filter) {
        this.$refs.pagination && this.$refs.pagination.clear();
        this.filter = filter;
        this.filter.order_status = Array.isArray(this.filter.order_status) ? this.filter.order_status.join(",") : this.filter.order_status;
        this.getList();
    };
    RejectStockInOrder.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data;
            var data = Array.isArray(DATA.data) ? DATA.data : [];
            _.forEach(data, function (item) {
                item.listGoods = [];
                (item.items || []).push({ isBtn: true });
            });
            _this.listData = data;
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    RejectStockInOrder.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    RejectStockInOrder = __decorate([
        Component({
            components: {
                'list-header': Header,
            },
        })
    ], RejectStockInOrder);
    return RejectStockInOrder;
}(Vue));
export default RejectStockInOrder;
